import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions:
		{
			async role ({ commit, state, dispatch, rootState }, payload) {
				/**
       * MA6没有用户登录功能, 所以直接在role阶段就进行根据参数查询用户详情的操作;
       */
				let queryParams: Array<string> = (window.location as any).href.match(/[^#?&]+=[^#?&]+/gi) || [];
				let params: any = {};
				while (queryParams.length) {
					let query = (queryParams as any).shift().split('=');
					params[query[0]] = query[1];
				}

				let token: string = params.token || localStorage.getItem('ma6_token') || '';
				let tenantId: string = params.businessEntityId || localStorage.getItem('ma6_businessEntityId') || '';
				let tenantType: string =
					params.businessEntityTypeId || localStorage.getItem('ma6_businessEntityTypeId') || '';
				let systemId: string = params.systemId || localStorage.getItem('ma6_systemId') || '';
				let parentBusinessEntityId: string =
					params.parentBusinessEntityId || localStorage.getItem('ma6_parentBusinessEntityId') || '';
				let parentBusinessEntityTypeId: string =
					params.parentBusinessEntityTypeId || localStorage.getItem('ma6_parentBusinessEntityTypeId') || '';
				let parentName: string = params.parentName || localStorage.getItem('ma6_parentName') || '';
				let accountId: string = params.accountId || localStorage.getItem('ma6_accountId') || '';
				let params_info: any = {
					token,
					tenantId,
					tenantType,
					systemId,
					accountId,
					parentBusinessEntityId,
					parentBusinessEntityTypeId,
					parentName,
				};

				for (let i in params_info) {
					if (params_info[i] && params_info[i] != 'null' && params_info[i] != 'undefined') {
						params_info[i] = params_info[i];
					} else {
						params_info[i] = '';
					}
				}

				var { error, success }: any = await router.app.$request('USERINFO', params_info);
				// const routes: Array<string> = []
				// const success: any = {
				// 	data: {
				// 		token: "6913b197a9734d06bc3e5a4ead4f3dc6",
				// 		businessEntity: {
				// 			businessEntityLogoUri: '1',
				// 			businessEntityNameCn: '1',
				// 		},
				// 		accountId: '1',
				// 		userName: '1',
				// 		accountDesc: '1',
				// 	}
				// }
				if (success && success.data.token) {
					//关键信息存到本地存储中, 刷新后可以使用这些信息做自动登录;
					localStorage.setItem('ma6_token', params_info.token);
					localStorage.setItem('ma6_businessEntityId', params_info.tenantId);
					localStorage.setItem('ma6_businessEntityTypeId', params_info.tenantType);
					localStorage.setItem('ma6_systemId', params_info.systemId);
					localStorage.setItem('ma6_parentBusinessEntityId', params_info.parentBusinessEntityId);
					localStorage.setItem('ma6_parentBusinessEntityTypeId', params_info.parentBusinessEntityTypeId);

					//设置全局header, 后面的所有请求都会带上这些header信息
					router.app.$request.setHeader('token', params_info.token);
					router.app.$request.setHeader('tenantId', params_info.tenantId);
					router.app.$request.setHeader('tenantType', params_info.tenantType);

					//设置全局变量, 在项目任何需要的地方都可以很方便的使用这些变量, 并且这些变量是双向绑定的.
					router.app.$global.set('tenantId', params_info.tenantId);
					router.app.$global.set('tenantType', params_info.tenantType);
					router.app.$global.set('token', success.data.token);
					router.app.$global.set('parentBusinessEntityId', params_info.parentBusinessEntityId);
					router.app.$global.set('parentBusinessEntityTypeId', params_info.parentBusinessEntityTypeId);
					router.app.$global.set('tenantName', (success.data.businessEntity || {}).businessEntityNameCn);
					router.app.$global.set('uId', success.data.accountId);
					router.app.$global.set('uName', success.data.userName);
					router.app.$global.set('uDesc', success.data.accountDesc);
					router.app.$global.set('uLogo', success.data.businessEntity.businessEntityLogoUri);
					router.app.$global.set('uPhone', success.data.mobilePhone);
					router.app.$global.set('uBusinessEntity', success.data.businessEntity);
					router.app.$global.set('parentName', params_info.parentName);
					// if (success.data.resources) {
					//   function deep(nodes: any) {
					//     nodes.forEach((element: any) => {
					//       routes.push(element.key)
					//       if (element.childList) {
					//         deep(element.childList)
					//       }
					//     });

					//   }
					//   deep(success.data.resources)
					//   // success.data.resources[0].childList.map((item: any) => {
					//   //   routes.push(item.key)
					//   // })
					// }
					// routes.push('/home')
					// routes.push('/mine')
					// console.log(routes)
					// router.app.$global.set('routes', routes);
				}
				error && console.error('警告: login出现未知错误了!');

				/**
          * 根据返回的权限树(节点)注册路由;
          * 参数params为单个权限节点或数组形式的多个权限节点或"*"号, 如:
          * "*" : 表示所有权限节点全部都无序注册
          * ["/", "/about", "/other", ...] : 表示有序注册指定权限节点
          */
				const ma6_find = (list: Array<any>) => list.find((item: any) => /^zuker$/i.test(item.key));
				const ma6_tree = (((success || {}).data || {}).resources || [])
					.map((item: any) => {
						if (/^zuker$/i.test(item.key)) {
							return item;
						}
						const child = ma6_find(item.childList || []);
						if (child) {
							return child;
						}
						return {};
					})
					.shift();
				const routes: Array<string> = ((ma6_tree || {}).childList || [])
					.sort((a: any, b: any) => {
						return a.order - b.order;
					})
					.map((item: any) => {
						if (item.key) {
							return item.key;
						}
						return null;
					})
					.filter((item: any) => !!item);

				const ma6_tree_loop = (list: Array<any>) =>
					list
						.sort((a: any, b: any) => {
							return a.order - b.order;
						})
						.map((item: any) => {
							if (item.key && item.nameCn) {
								return { path: item.key, title: item.nameCn };
							}
							return null;
						})
						.filter((item: any) => !!item);
				const routes_global: Array<any> = ((ma6_tree || {}).childList || [])
					.sort((a: any, b: any) => {
						return a.order - b.order;
					})
					.map((item: any) => {
						if (item.key && item.nameCn) {
							let route: any = { path: item.key, title: item.nameCn };
							if (item.childList && item.childList.length) {
								route.children = ma6_tree_loop(item.childList);
							}
							return route;
						}
						return null;
					})
					.filter((item: any) => !!item);
				let newArr: any = [];
				routes_global &&
					routes_global.forEach(item => {
						newArr.push(item.path);
					});
				newArr.push('/home');
				newArr.push('/mine');
				router.app.$global.set('addVerificationByManual', '');
				if(newArr.indexOf('/couponVerification') == -1) {
					newArr.push('/couponVerification');
					router.app.$global.set('addVerificationByManual', '/couponVerification');
				}
				
				router.app.$global.set('routes', newArr);
				// const routes: Array<string> = [
				//   '/',
				//   '/manageHome',
				//   '/store',
				//   '/activity',
				//   '/coupon',
				//   '/member',
				//   '/mall',
				//   '/database',
				//   '/settlement',
				//   '/task',
				//   '/zuker',
				//   '/support',
				//   '/couponCancel',
				//   '/couponPutin',
				//   '/couponVerification',
				//   '/mine',
				//   '/mine/shop',
				//   '/mine/market',
				//   '/activityManagement',
				//   '/searchMember',
				//   '/faceCoupon'
				// ];
				return Promise.resolve(newArr);
				//返回路由数组, 如果当前页面初始化时的路由不在返回的路由数组中, 则重定向到404(如果有)或路由数组的第1个路由;
				//return Promise.resolve({ routes, default: '/'});
				//返回路由对象, 如果当前页面初始化时的路由不在routes数组中, 则重定向到default指定的路由中, 如果省略default, 则重定向到404(如果有)或路由数组的第1个路由;
			},
		},
});
